const INIT_STATE = { emp_time: false }

const emp_time = (state = INIT_STATE, action) => {
  switch (action.type) {
    case "UPDATE_TIME":
      return {
        ...state,
        emp_time: !state.emp_time,
      } 

    default:
      return state
  }
}

export default emp_time
